import { useQueryClient } from "@tanstack/react-query"
import { useCallback } from "react"
import { SessionApiResource } from "source/shared/SessionApiResource"

export const useInvalidateCache = (baseUrl: string) => {
  const queryClient = useQueryClient()
  const [_queryFn, queryKey] = SessionApiResource(baseUrl)

  const invalidate = useCallback(
    () => queryClient.invalidateQueries({ queryKey: [queryKey] }),
    [queryClient, queryKey],
  )

  return invalidate
}
